export default "__VITE_ASSET__CUkihylm__"